module.exports = __webpack_public_path__ + "assets/images/CHF10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CHF10.png
// module id = 1336
// module chunks = 1